import {
  KMFC_BANK_REFERENCE_DATA_SET_VALUE,
  KMFC_BRANCH_CODES_REFERENCE_DATA_API_STATUS,
  KMFC_BRANCH_CODES_REFERENCE_DATA_SET_VALUE,
  KMFC_SET_REF_NUMBER,
  RESET_REFERENCE_DATA,
} from "../../actions/kaMetlhaFuneralClaim/referenceData";

export const initReferenceData = {
  apiStatus:null,
  applicationData: {
    bankData: null,
    branchCodesData: null,
  },
  buyRef:null
};

export default (state = initReferenceData, action) => {
  switch (action.type) {
    case KMFC_BRANCH_CODES_REFERENCE_DATA_API_STATUS:
      return {...state, apiStatus: action.value };

      case KMFC_BANK_REFERENCE_DATA_SET_VALUE:
      return {...state,
        applicationData: { ...state.applicationData, bankData: action.value },
      };
   
      case KMFC_BRANCH_CODES_REFERENCE_DATA_SET_VALUE:
      return {
        ...state,
        applicationData: {
          ...state.applicationData,
          branchCodesData: action.value,
        },
      };
    case KMFC_SET_REF_NUMBER:
      return {
        ...state,
        buyRef:action?.value
      }
    case RESET_REFERENCE_DATA:
      return { ...initReferenceData };
    default:
      return state;
  }
};
